var setPrototypeOf = require('./setPrototypeOf.js');
function _inherits(t, e) {
    if ('function' != typeof e && null !== e)
        throw new TypeError('Super expression must either be null or a function');
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, 'prototype', { writable: !1 }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports['default'] = module.exports;